import { FC, MouseEvent, ReactNode } from 'react'
import cn from './index.module.css'
import { Checkbox } from 'antd'

interface IFolderItem {
  label: string
  value: boolean
  onChange: (value: boolean) => void
}

const FolderItem: FC<IFolderItem> = ({ label, value, onChange }) => {
  const setValue = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    onChange(!value)
  }

  return (
    <button className={cn.wrapper} onClick={setValue}>
      <Checkbox checked={value} className={cn.checkbox} />
      <span className={cn.label}>{label}</span>
    </button>
  )
}

export default FolderItem
